import { UserRole, UserStatus, UserPosition } from "./users-response.interface";

export interface CreateUserInterface {
  id: string;
  email: string;
  role: UserRole;
  first_name?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  status: UserStatus;
  position?: UserPosition;
  created_by_id: string | null;
  updated_by_id: string | null;
  attachment_signature_id?: string | null;
  attachment_avatar_id?: string | null;
}

export interface UpdateUserInterface {
  id: string;
  email?: string;
  role: UserRole;
  first_name?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  status?: UserStatus;
  position?: UserPosition;
  updated_by_id: string | null;
  attachment_signature_id?: string | null;
  attachment_avatar_id?: string | null;
}